@if(!loading) {
<div class="padding header">
    <div>
        <h1 id="hubReportHeader">{{ 'hubReport.hubReport' | transloco }}</h1>
        @if (envelope?.statusLastUpdated) {
        {{ 'common.labels.updatedOn' | transloco: { date: (envelope!.statusLastUpdated | localizedDate) } }}
        }
    </div>
    @if(envelope?.document) {
    <button style="padding: 0px 15px;" (click)="downloadHubReport()" mat-flat-button color="accent"
        [attr.aria-label]="'hubReport.downloadHubReportButton' | transloco" data-testid="download-hub-report-button">
        <mat-icon aria-hidden="false" [attr.aria-label]="'common.labels.downloadIcon' | transloco">download</mat-icon>
        <mat-label>{{ 'common.labels.downloadDocument' | transloco }}</mat-label>
    </button>
    }
</div>
}

<div class="padding" id="order_tree"></div>

@if(!loading) {
<div class="padding">
    <mat-tab-group class="top-level-tab-group" [(selectedIndex)]="tabIndex"
        (selectedTabChange)="onSelectedTabChange($event)">
        <mat-tab [label]="'hubReport.ownershipSummary' | transloco">
            <mat-card class="card-margin">
                <mat-card-content>
                    <span>{{ 'hubReport.totalEffectiveOwnershipOf' | transloco: { name: root?.businessReportParsedResults?.name ?? ('hubReport.theBusinessInQuestion' | transloco) } }}</span>
                    @if(ownershipRecords.length === 0) {
                    <span> {{ 'hubReport.nA' | transloco }}</span>
                    } @else {
                    <div class="margin-top-15 margin-bottom-15">
                        @for(record of ownershipRecords; track record) {
                        <div class="flex-container">
                            <div class="flex-item-2">{{ record.label }}:</div>
                            <div class="flex-item">{{ record.percentage.toFixed(2) }}%</div>
                        </div>
                        }
                    </div>
                    }
                    <div>{{ 'hubReport.remainingUltimateBeneficialOwnershipPercentage' | transloco }}
                        @if (ownershipRecords.length === 0) {
                        <span class="bold">100%</span>
                        } @else {
                        <span class="bold">{{ outstandingOwnership.toFixed(2) }}%</span>
                        }
                    </div>
                </mat-card-content>
            </mat-card>
        </mat-tab>
        @if (hasPepsAndSanctions) {
        <mat-tab [label]="'hubReport.pepsAndSanctions' | transloco">
            <mat-card class="card-margin">
                <mat-card-content>
                    <lib-parties-list [observableParties$]="pepsAndSanctionsParties$" [order]="orders.at(0)!"
                        [uiConfiguration]="getPepsAndSanctionsPartiesUiConfiguration()"></lib-parties-list>
                </mat-card-content>
            </mat-card>
        </mat-tab>
        }
        @for (tab of tabs; track tab) {
        <mat-tab [label]="tab.label">
            <mat-tab-group class="mid-level-tab-group">
                <mat-tab class="bottom-level">
                    <ng-template mat-tab-label>
                        <div class="flex-container-vertical-center flex-container-space-between">
                            <span class="flex-item">{{ 'common.labels.actions' | transloco }}</span>
                        </div>
                    </ng-template>
                    <mat-card class="card-margin">
                        <mat-card-content>
                            @if(tab.node !== root) {
                            <div class="margin-bottom-15">{{ tab.label }} {{ 'hubReport.owns' | transloco }} <span class="bold">{{
                                    getTabOwnershipPercentage(tab) }}%</span> {{ 'hubReport.of' | transloco }}
                                {{ tab.parentNode?.businessReportParsedResults?.name }}.</div>
                            }
                            <div>{{ 'hubReport.ultimateBeneficialOwnershipFlow' | transloco }}</div>
                            @if (tab.node !== root && !(tab.shareholder?.isValidated ?? false)) {
                            <div class="flex-container-vertical-center"><mat-icon
                                    class="icon-warning margin-right-5">warning</mat-icon> {{ 'hubReport.theAttestorDidNotValidateThis' | transloco }}</div>
                            }
                            <mat-list>
                                @if(tab.node !== root && !(tab.shareholder?.isValidated ?? false)) {
                                <mat-list-item>
                                    <mat-icon matListItemIcon>counter_1</mat-icon>
                                    <div matListItemTitle>
                                        @if (shouldShowBusinessReportAction(tab)) {
                                        <button (click)="orderBusinessSearch(tab)" mat-flat-button color="accent"
                                            [attr.aria-label]="'hubReport.orderBusinessSearchButton' | transloco"
                                            data-testid="order-business-search-button"
                                            [disabled]="isUsEntity(tab)">
                                            <mat-label>{{ 'hubReport.orderABusinessSearch' | transloco }}</mat-label>
                                        </button>
                                        } @else {
                                        <span class="text-faded done">{{ 'hubReport.orderABusinessSearch' | transloco }}</span>
                                        }
                                    </div>
                                </mat-list-item>
                                }
                                <mat-list-item>
                                    <mat-icon matListItemIcon>counter_{{ tab.node !== root &&
                                        (tab.shareholder?.isValidated ?? false) ? '1' : '2'}}</mat-icon>
                                    <div matListItemTitle>
                                        @if(shouldShowBusinessReportAction(tab)) {
                                        <button [disabled]="!shouldShowBusinessReportAction(tab) || isUsEntity(tab)"
                                            (click)="orderBusinessReport(tab)" mat-flat-button color="accent"
                                            [attr.aria-label]="'hubReport.orderBusinessReportButton' | transloco"
                                            data-testid="order-business-report-button">
                                            <mat-label>{{ 'hubReport.orderABusinessReport' | transloco }}</mat-label>
                                        </button>
                                        } @else {
                                        <span class="text-faded done">{{ 'hubReport.orderABusinessReport' | transloco }}</span>
                                        }
                                    </div>
                                    @if(tab.node?.businessReportOrder) {
                                    <div matListItemLine>
                                        <span>{{ 'common.labels.orderStatus' | transloco }}: <span class="bold">{{
                                                getOrderStatus(tab.node!.businessReportOrder) }}</span></span>
                                    </div>
                                    }
                                    @if (tab.node?.businessReportOrder) {
                                    <div matListItemLine>
                                        <a role="link" tabindex="0" (click)="viewOrder(tab.node!.businessReportOrder, false)" (keydown.enter)="viewOrder(tab.node!.businessReportOrder, false)">{{ 'hubReport.goToBusinessReportOrder' | transloco }}</a>
                                    </div>
                                    }
                                </mat-list-item>
                                <mat-list-item>
                                    <mat-icon matListItemIcon>counter_{{ tab.node !== root &&
                                        (tab.shareholder?.isValidated ?? false) ? '2' : '3' }}</mat-icon>
                                    <div matListItemTitle>
                                        @if(shouldShowUboAction(tab)) {
                                        <button
                                            [disabled]="shouldShowBusinessReportAction(tab) || tab.node?.businessReportOrder?.orderStatusTypeID !== 'Complete'"
                                            (click)="orderUbo(tab)" mat-flat-button color="accent"
                                            [attr.aria-label]="'hubReport.orderUboButton' | transloco" data-testid="order-ubo-button">
                                            <mat-label>{{ 'hubReport.orderAnUltimateBeneficialOwnershipReport' | transloco }}</mat-label>
                                        </button>
                                        } @else {
                                        <span class="text-faded done">{{ 'hubReport.orderAnUltimateBeneficialOwnershipReport' | transloco }}</span>
                                        }
                                    </div>
                                    @if(tab.node?.uboOrder) {
                                    <div matListItemLine>
                                        <span>{{ 'common.labels.orderStatus' | transloco }}: <span class="bold">{{ getOrderStatus($safeNavigationMigration(tab.node?.uboOrder))
                                                }}</span></span>
                                    </div>
                                    }
                                    @if(tab.node?.uboOrder) {
                                    <div matListItemLine>
                                        <a role="link" tabindex="0" (click)="viewOrder(tab.node!.uboOrder!, false)" (keydown.enter)="viewOrder(tab.node!.uboOrder!, false)">{{ 'hubReport.goToUboReportOrder' | transloco }}</a>
                                    </div>
                                    }
                                </mat-list-item>
                            </mat-list>
                        </mat-card-content>
                    </mat-card>
                </mat-tab>
                @if(tab.node?.businessReportOrder && tab.node?.businessReportOrder?.orderStatusTypeID === 'Complete') {
                <mat-tab class="bottom-level">
                    <ng-template mat-tab-label>
                        <div class="flex-container-vertical-center flex-container-space-between">
                            <span class="flex-item">{{ 'hubReport.businessReport' | transloco }}</span>
                            <button class="flex-item menu" (click)="$event.stopPropagation()" mat-icon-button
                                [matMenuTriggerFor]="menu" [attr.aria-label]="'hubReport.orderActionsMenu' | transloco">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button (click)="viewOrder(tab.node!.businessReportOrder)" mat-menu-item>
                                    <mat-icon color="primary">open_in_new</mat-icon>
                                    <span>{{ 'common.labels.viewOrder' | transloco }}</span>
                                </button>
                                @if(hasRegistryDocument(tab.node!.businessReportOrder)) {
                                <button (click)="openRegistryDocument(tab.node!.businessReportOrder)" mat-menu-item>
                                    <mat-icon color="primary">download</mat-icon>
                                    <span>{{ 'hubReport.registryDocument' | transloco }}</span>
                                </button>
                                }
                                @if(hasRegHubDocument(tab.node!.businessReportOrder)) {
                                <button (click)="openRegHubDocument(tab.node!.businessReportOrder)" mat-menu-item>
                                    <mat-icon color="primary">download</mat-icon>
                                    <span>{{ 'hubReport.reghubDocument' | transloco }}</span>
                                </button>
                                }
                            </mat-menu>
                        </div>
                    </ng-template>
                    <lib-business-report-results [order]="tab.node!.businessReportOrder"
                        [results$]="getBusinessReportResultsSubject(tab.node!.businessReportOrder.id)"></lib-business-report-results>
                </mat-tab>
                }
                @if (tab.node?.uboOrder && tab.node?.uboOrder?.orderStatusTypeID === 'Complete') {
                <mat-tab class="bottom-level">
                    <ng-template mat-tab-label>
                        <div class="flex-container-vertical-center flex-container-space-between">
                            <span class="flex-item">{{ 'hubReport.ultimateBeneficialOwnershipReport' | transloco }}</span>
                            <button class="flex-item menu" (click)="$event.stopPropagation()" mat-icon-button
                                [matMenuTriggerFor]="menu" [attr.aria-label]="'hubReport.orderActionsMenu' | transloco">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button (click)="viewOrder(tab.node!.uboOrder!)" mat-menu-item>
                                    <mat-icon color="primary">open_in_new</mat-icon>
                                    <span>{{ 'common.labels.viewOrder' | transloco }}</span>
                                </button>
                                @if(hasRegHubDocument(tab.node!.uboOrder!)) {
                                <button (click)="openRegHubDocument(tab.node!.uboOrder!)" mat-menu-item>
                                    <mat-icon color="primary">download</mat-icon>
                                    <span>{{ 'hubReport.reghubDocument' | transloco }}</span>
                                </button>
                                }
                            </mat-menu>
                        </div>
                    </ng-template>
                    <lib-ubo-order-details-tab-group [order]="tab.node!.uboOrder!" [uiConfiguration]="uboOrderConfiguration" [admin]="isAdmin"></lib-ubo-order-details-tab-group>
                </mat-tab>
                }
            </mat-tab-group>
        </mat-tab>
        }
    </mat-tab-group>
</div>
} @else {
<div class="loading-spinner-overlay">
    <mat-spinner></mat-spinner>
</div>
}